export const styles = {
  sectionContainer: {
    backgroundColor: "#000000a3",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundBlendMode: "darken",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    width: {
      xs: "100%",
      sm: "100%",
      md: "100%",
      lg: "100%",
    },
    minHeight: {
      xs: "100%",
      sm: "100%",
      md: "100%",
      lg: "683px",
    },
  },
  content: {
    width: "1440px",
    maxWidth: "1440px",
    height: "100%",
    boxSizing: "border-box",
    padding: "100px 80px 100px 80px",
    position: "relative",
  },
  sectionTitle: {
    color: "white",
    textAlign: { xs: "center", md: "right" },
    fontSize: {
      xs: "24px",
      sm: "1.5rem",
      md: "1.5rem",
      lg: "64px",
    },
    marginRight: "1rem",
    fontFamily: "IBM Plex Sans, Roboto",
    textTransform: "uppercase",
    marginBottom: "80px",
  },
  sectionTitleAccent: {
    color: "white",
    textAlign: { xs: "center", md: "left" },
    fontSize: {
      xs: "24px",
      sm: "1.5rem",
      md: "1.5rem",
      lg: "64px",
    },
    fontWeight: "bold",
  },
};

export default styles;
